import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchBundlesFailure,
  fetchBundlesSuccess,
  getHistoryFailure,
  getHistorySuccess,
  getPaymentListFailure,
  getPaymentListSuccess,
  subscribeFailure,
  subscribeSuccess,
  updateSubscribeFailure,
  updateSubscribeSuccess,
  getSubListSuccess,
  getSubListFailure,
  addMethodSuccess,
  addMethodFailure,
  deleteMethodSuccess,
  deleteMethodFailure,
  getPaymentList as getPaymentListAction,
  cancelSubscriptionSuccess,
  cancelSubscriptionFailure,
  setDefaultSuccess,
  setDefaultFailure,
  reqDemoSuccess,
  reqDemoFailure,
} from "./actions";
import {
  FETCH_BUNDLES,
  GET_HISTORY,
  GET_PAYMENT_LIST,
  SUBSCRIBE,
  UPDATE_SUBSCRIBE,
  GET_SUB_LIST,
  ADD_METHOD,
  DELETE_METHOD,
  CANCEL_SUBSCRIPTION,
  SET_DEFAULT,
  REQ_DEMO,
} from "./constants";
import authAction from "../Auth/actions";

export function* fetchBundlesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/package-item?${query}`);
    yield put(fetchBundlesSuccess(data));
  } catch (e) {
    yield put(fetchBundlesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching bundles!"));
  }
}
export function* subscribeSaga({ payload, onSuccess, history, selectedMode }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/create-subscription`,
      payload
    );
    yield put(subscribeSuccess({ ...payload, ...data }));
    if (data) {
      typeof onSuccess === "function" &&
        onSuccess({ ...payload, ...data, selectedMode });
    }
  } catch (e) {
    yield put(subscribeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while subscribing!"));
  }
}
export function* updateSubscribeSaga({ payload, onUpdateSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/update-subscription/${payload?.id}`,
      payload?.response
    );
    yield put(updateSubscribeSuccess(data));
    if (data) {
      typeof onUpdateSuccess === "function" &&
        onUpdateSuccess({ ...payload, ...data });
    }
  } catch (e) {
    yield put(updateSubscribeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while subscribing!"));
  }
}

export function* getPaymentSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-payment-methods/${payload}`
    );
    yield put(getPaymentListSuccess(data));
  } catch (e) {
    yield put(getPaymentListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching payment list!"));
  }
}

export function* getHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-billing_details?${query}`
    );
    yield put(getHistorySuccess(data));
  } catch (e) {
    yield put(getHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching history list!"));
  }
}

export function* getSubListSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/subscription-item?${query}`
    );
    yield put(getSubListSuccess(data));
  } catch (e) {
    yield put(getSubListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching subscription list!"));
  }
}

export function* addMethodSaga({ payload, onAddSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/customer-payment-attach`,
      payload
    );
    yield put(addMethodSuccess(data));
    typeof onAddSuccess === "function" && onAddSuccess();
  } catch (e) {
    yield put(addMethodFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while adding card!"));
  }
}

export function* deleteMethodSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/delete-payment-method/${payload}`
    );
    yield put(deleteMethodSuccess(data));
    yield put(getPaymentListAction(user?.stripe_customer_id));
  } catch (e) {
    yield put(deleteMethodFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting card!"));
  }
}

export function* cancelSubscriptionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/cancel-subscription/${payload}`
    );
    yield put(cancelSubscriptionSuccess());
    yield put(authAction.check(token));
  } catch (e) {
    yield put(cancelSubscriptionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating!"));
  }
}

export function* setDefaultSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/update-customer/${user?.stripe_customer_id}`,
      payload
    );
    yield put(successAlert("Default payment method has been updated!"));
    yield put(setDefaultSuccess());
    yield put(getPaymentListAction(user?.stripe_customer_id));
  } catch (e) {
    yield put(setDefaultFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating!"));
  }
}

export function* reqDemoSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/schedule-demo`, payload);
    yield put(successAlert("Demo request sent successfully!"));
    yield put(reqDemoSuccess());
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(reqDemoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while requesting demo!"));
  }
}

export function* fetchBundlesFlow() {
  yield takeEvery(FETCH_BUNDLES, fetchBundlesSaga);
}
export function* subscribeFlow() {
  yield takeEvery(SUBSCRIBE, subscribeSaga);
}
export function* updateSubscribeFlow() {
  yield takeEvery(UPDATE_SUBSCRIBE, updateSubscribeSaga);
}
export function* getPaymentFlow() {
  yield takeEvery(GET_PAYMENT_LIST, getPaymentSaga);
}
export function* getHistoryFlow() {
  yield takeEvery(GET_HISTORY, getHistorySaga);
}
export function* getSubListFlow() {
  yield takeEvery(GET_SUB_LIST, getSubListSaga);
}
export function* addMethodFlow() {
  yield takeEvery(ADD_METHOD, addMethodSaga);
}
export function* deleteMethodFlow() {
  yield takeEvery(DELETE_METHOD, deleteMethodSaga);
}
export function* cancelSubscriptionFlow() {
  yield takeEvery(CANCEL_SUBSCRIPTION, cancelSubscriptionSaga);
}
export function* setDefaultFlow() {
  yield takeEvery(SET_DEFAULT, setDefaultSaga);
}
export function* reqDemoFlow() {
  yield takeEvery(REQ_DEMO, reqDemoSaga);
}

export default function* BundlesSaga() {
  yield all([
    fetchBundlesFlow(),
    subscribeFlow(),
    updateSubscribeFlow(),
    getPaymentFlow(),
    getHistoryFlow(),
    getSubListFlow(),
    addMethodFlow(),
    deleteMethodFlow(),
    cancelSubscriptionFlow(),
    setDefaultFlow(),
    reqDemoFlow(),
  ]);
}
